import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Side-effect imports: i18n must initialize before any t() call;
// theme must apply data-theme on <html> before first paint to avoid
// a flash of light when the user prefers dark.
import './lib/i18n';
import './lib/theme';
import { App } from './App.tsx';
import './styles/app.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
